import React from 'react'
import "./styles/Campos.css"

export const CampoInput = ({label, className, ...props}) => {
    return (
        <div className={`campo_input ${className}`}>
            <label>{label}
                <div><input {...props} /></div>
            </label>
        </div>
    )
}

export const CampoVer = ({label, className, value, ...props}) => {
    return (
        <div className={`campo_ver form-group ${className}`}>
            <label>{label}</label>
            <div {...props}>{value}</div>
        </div>
    )
}